import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import "./index.css";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import { Transaction } from "../../redux/services/dashboardService";
import DataTable, { TableColumn } from "react-data-table-component";

// interface PaymentAccordianDetail {
//   id: number;
//   title: string;
//   value: string;
//   body: string;
// }

interface ContextAwareToggleProps {
  children: React.ReactNode;
  eventKey: string;
  isExpanded: boolean;
  onToggle: (eventKey: string) => void;
}

function ContextAwareToggle({
  children,
  eventKey,
  isExpanded,
  onToggle,
}: ContextAwareToggleProps) {
  const decoratedOnClick = useAccordionButton(eventKey, () => {
    onToggle(eventKey);
  });

  return (
    <div className="breackdownrtnbtnprice">
      <button
        type="button"
        className="breakdownaccordianbtn"
        onClick={decoratedOnClick}
      >
        <FontAwesomeIcon
          icon={isExpanded ? faChevronDown : faChevronRight}
          className="Arrow-Icon"
          id="brekDownSVG"
        />
        {children}
      </button>
    </div>
  );
}

interface BreakDownAccordionProps {
  refundsTotal: number;
  myEarningsTotal?: number;
  marketingSpendTotal: number;
  curryKingFeesTotal: number;
  otherPaymentsTotal: number;
  cartCommissionsTotal:number;
  salesTotal:number;
  refundsTransactions: Transaction[];
  earningsTransactions: Transaction[];
  marketingSpendTransactions: Transaction[];
  curryKingFeesTransactions: Transaction[];
  salesTransactions:Transaction[];
  cartCommissionsTransactions:Transaction[];
  otherPaymentsTransactions: Transaction[];
}

const BreakDownAccordion: React.FC<BreakDownAccordionProps> = ({
  refundsTotal,
  // myEarningsTotal,
  marketingSpendTotal,
  curryKingFeesTotal,
  cartCommissionsTotal,
  salesTotal,
  otherPaymentsTotal,
  refundsTransactions,
  // earningsTransactions,
  marketingSpendTransactions,
  curryKingFeesTransactions,
  cartCommissionsTransactions,
  salesTransactions,
  otherPaymentsTransactions,
}) => {
  const paymentAccordianDetails = [
    {
      id: 1,
      title: "Curry King Fees",
      totalAmount: `Rs: ${curryKingFeesTotal.toFixed(2)}`,
      transactions: curryKingFeesTransactions,
    },
    {
      id: 2,
      title: "Cart Commissions",
      totalAmount: `Rs: ${cartCommissionsTotal.toFixed(2)}`,
      transactions: cartCommissionsTransactions,
    },
    {
      id: 3,
      title: "Sales Payments",
      totalAmount: `Rs: ${salesTotal.toFixed(2)}`,
      transactions: salesTransactions,
    },
    {
      id: 4,
      title: "Refunds",
      totalAmount: `Rs: ${refundsTotal.toFixed(2)}`,
      transactions: refundsTransactions,
    },
    // {
    //   id: 2,
    //   title: "My Earnings",
    //   totalAmount: `Rs: ${myEarningsTotal.toFixed(2)}`,
    //   transactions: earningsTransactions,
    // },
    // {
    //   id: 5,
    //   title: "Marketing Spend",
    //   totalAmount: `Rs: ${marketingSpendTotal.toFixed(2)}`,
    //   transactions: marketingSpendTransactions,
    // },
  
    // {
    //   id: 6,
    //   title: "Other Payments",
    //   totalAmount: `Rs: ${otherPaymentsTotal.toFixed(2)}`,
    //   transactions: otherPaymentsTransactions,
    // },
  ];

  const [expanded, setExpanded] = useState<string | null>(null);

  const handleToggle = (eventKey: string) => {
    setExpanded(expanded === eventKey ? null : eventKey);
  };

  // helper function to convert the timestamp to date format
  const formatDate = (createdAt: {
    _seconds: number;
    _nanoseconds: number;
  }) => {
    const date = new Date(createdAt._seconds * 1000);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const transactionColumns: TableColumn<Transaction>[] = [
    {
      name: <h6 className="fw-bold">Created Date</h6>,
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: <h6 className="fw-bold">Description</h6>,
      selector: (row) => row.description,
      sortable: false,
    },
    {
      name: <h6 className="fw-bold">Payment Method</h6>,
      selector: (row) => row.paymentMethod,
      sortable: false,
    },
    {
      name: <h6 className="fw-bold">Type</h6>,
      selector: (row) => row.type,
      sortable: false,
    },
    {
      name: <h6 className="fw-bold">Amount (Rs.)</h6>,
      selector: (row) => row.amount.toFixed(2),
      sortable: true,
      right:true
    },
  ];

  return (
    <div>
      <Accordion defaultActiveKey="0" className="breakdownaccordianwhole">
        {paymentAccordianDetails.map((detail) => (
          <Card key={detail.id} className="breakdownaccordiancard">
            <Card.Header className="breakdowncardheader">
              <ContextAwareToggle
                eventKey={detail.id.toString()}
                isExpanded={expanded === detail.id.toString()}
                onToggle={handleToggle}
              >
                <div className="accordion-title-value">
                  <span>{detail.title}</span>
                  <span>{detail.totalAmount}</span>
                </div>
              </ContextAwareToggle>
            </Card.Header>
            <Accordion.Collapse
              eventKey={detail.id.toString()}
              in={expanded === detail.id.toString()}
            >
              <Card.Body className="card-body-breakdown-style" >
                <DataTable
                  columns={transactionColumns}
                  data={detail.transactions}
                  pagination
                  highlightOnHover
                  noDataComponent="No transactions available"
                />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
    </div>
  );
};

export default BreakDownAccordion;